import React, { useEffect, useState } from 'react';
import Loader from './Loader';

/**
 * Suspense fallback for route chunks.
 *
 * Route components are code-split, so navigating fetches a chunk. Most chunks
 * resolve in well under 200ms, and showing the full-screen blurred loader for
 * that long reads as a flicker on every click. Nothing is rendered until the
 * wait is actually long enough to be worth acknowledging.
 */
const RouteFallback = ({ delayMs = 200 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  return visible ? <Loader /> : null;
};

export default RouteFallback;
